import { PrintTicket } from './print-ticket';

export interface WebPrintRequestJob {
    printerName: string;
    document: string;
    ticket: PrintTicket | null;
}

export enum WebPrintRequestFunction {
    SUBMIT = 'submit',
    CANCEL = 'cancel',
}

export interface WebPrintSubmitRequest {
    type: WebPrintRequestFunction.SUBMIT;
    job: WebPrintRequestJob;
}

export interface WebPrintCancelRequest {
    type: WebPrintRequestFunction.CANCEL;
    jobId: string;
}

export type WebPrintRequest = WebPrintSubmitRequest | WebPrintCancelRequest;
